import type { UsuarioStatus } from '../../../model/kartera-api-model'

export { AVATAR_TONES, errorMessage, formatCount, initials, personName } from '../../customers/common/customer-common'

export const USERS_PATH = '/configuracion/usuarios'
export const USERS_BACK_PATH = '/configuracion'
export const NEW_USER_PATH = `${USERS_PATH}/nuevo`

export const userPath = (id: number) => `${USERS_PATH}/${id}`

export interface FormMessage {
    type: 'error' | 'success'
    message: string
}

/** `state` de navegación para mostrar un aviso al volver a la lista. */
export interface UsersLocationState {
    backUrl?: string
    flash?: string
}

export const STATUS_LABELS: Record<UsuarioStatus, string> = {
    activo: 'Activo',
    pendiente: 'Pendiente de activar',
    inactivo: 'Inactivo',
}

export const statusTone = (status?: UsuarioStatus | null) => {
    if (status === 'activo') return 'bg-k-ok-soft text-k-ok'
    if (status === 'pendiente') return 'bg-tone-orange text-tone-orange-ink'
    return 'bg-k-line-soft text-k-ink-2'
}
